<template>
    <div :class="flipped ? 'flip-container flipped': 'flip-container'" class="h-100" >
        <div class="flipper h-100">
            <div class="front h-100 " :style="frontStyle">
                <slot name="front"></slot>
                <div style="position: absolute; top: 3px; right: 34px; color: white" v-if="backText">{{ backText }}</div>
                <v-icon
                    class="frontFlipBtn"
                    :style="style"
                    :class="color"
                    v-on:click="onFlip(true)"
                    v-if="enabled"
                    style="z-index: 1"
                >
                   {{ frontIcon }}
                </v-icon>
            </div>
            <div class="back h-100 ">
                <slot name="back"></slot>
                <div style="position: absolute; top: 3px; right: 34px; color: white" v-if="frontText">{{ frontText }}</div>
                <v-icon
                    class="backFlipBtn"
                    :style="style"
                    :class="color"
                    v-on:click="onFlip(false)"
                    style="z-index: 1"
                >
                    {{ backIcon }}
                </v-icon>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CFlipCard",
    props: {
        value: {

        },

        top: {
            required: false,
            type    : Number,
            default : function () {
                return 2;
            }
        },
        right: {
            required: false,
            type    : Number,
            default : function () {
                return 4;
            }
        },
        color: {
            required: false,
            type    : String
        },
        enabled:  {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },
        backText: {
            required: false,
        },

        frontText: {
            required: false,
        },

        frontIcon: {
            required: false,
            type    : String,
            default : function () {
                return "fas fa-exchange-alt";
            }
        },

        backIcon: {
            required: false,
            type    : String,
            default : function () {
                return "fas fa-exchange-alt";
            }
        },
    },

    data: () => ({
        flipped: false,
    }),

    created() {
        this.flipped = this.value;
    },

    watch: {
        value () {
            this.flipped = this.value;
        }
    },

    computed: {
        style () {
            return "color: " + this.color + "!important; top: " + this.top + "px; right: " +  this.right + "px;"
        },

        frontStyle () {
            return this.flipped ? "z-index: -1" : "z-index: 1";
        },

        backStyle () {
            return this.style; // + this.flipped ? "z-index: 1" : "z-index: -1";
        }
    },

    methods: {
        onFlip (value) {
            this.flipped = value;
            this.$emit("input", this.flipped);
        }
    }
}
</script>

<style scoped>

::v-deep .flip-container {
    -webkit-transition:width 300ms ease-in-out, height 300ms ease-in-out;
    -moz-transition:width 300ms ease-in-out, height 300ms ease-in-out;
    -o-transition:width 300ms ease-in-out, height 300ms ease-in-out;
    transition:width 300ms ease-in-out, height 300ms ease-in-out;
    height: 100%;
}

.frontFlipBtn,
.backFlipBtn {
    position: absolute!important;
}

.flipper {
    position: relative;
    perspective: 2000px;
    transition: transform 0.8s;
    height: 100%;
}

.front,
.back {
    position: absolute;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transition: all 0.5s ease-out 0s;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.back {
    transform: rotateY(-180deg);
}
.flip-container.flipped .back {
    transform: rotateY(0deg);
}

.flip-container.flipped .front {
    transform: rotateY(180deg);
}


</style>